<div class="input-group">
  <input
    class="form-control"
    placeholder="jj/mm/aaaa"
    name="dp"
    [(ngModel)]="model"
    (change)="checkInput()"
    (dateSelect)="selectInput()"
    ngbDatepicker
    #d="ngbDatepicker"
    [class.is-invalid]="invalid"
    [disabled]="isDisabled"
  />
  <div class="input-group-append">
    <button class="btn btn-primary calendar" [class.disabled]="isDisabled" (click)="d.toggle()" type="button" [disabled]="isDisabled">
      <fa-icon class="d-block" icon="calendar-alt"></fa-icon>
    </button>
  </div>
</div>
